import styled from 'styled-components';
export default styled.div.attrs((props) => ({
    'data-campaign': props.dataCampaign,
    'data-category': props.dataCategory,
})) `
	background-color: hsla(0, 0%, 100%, 0.25);
	border: solid 1px rgba(var(--theme-border-color--rgb, 195, 198, 198), 0.5);
	border-radius: 3px;
	margin: 30px 18px;

	@media (min-width: 320px) {
		max-width: 440px;
	}

	@media (min-width: 481px) {
		max-width: 820px;
	}

	clear: both;
`;
